import { useEffect, useRef } from "react";
import InvestigationMetadata from "./InvestigationMetadata.jsx";

export default function InvestigationCaseSettings({ collection, assignees, onClose }) {
    const dialog = useRef(null);
    useEffect(() => {
        const trigger = document.activeElement;
        dialog.current?.showModal();
        return () => { trigger?.focus({ preventScroll: true }); };
    }, []);
    return <dialog ref={dialog} className="investigation-case-settings" aria-label="Case settings" onCancel={(event) => { event.preventDefault(); if (!collection.busy) onClose(); }}>
        <InvestigationMetadata record={collection.record} collection={collection} assignees={assignees} onCancel={onClose} onSaved={onClose} onDeleted={onClose} includeVerdict={false} />
    </dialog>;
}
